import { Component, Input, OnInit, Output, EventEmitter, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import * as _ from 'lodash'
import { Subject } from 'rxjs';
import { NgIf, NgFor, NgStyle } from '@angular/common';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-ltms-dropdown',
    templateUrl: './ltms-dropdown.component.html',
    styleUrls: ['./ltms-dropdown.component.scss'],
    imports: [NgIf, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgFor, NgbDropdownButtonItem, NgbDropdownItem, NgStyle]
})
export class LtmsDropdownComponent implements OnInit, OnDestroy {
  @ViewChild('ltmsdropdown') ltmsdropdown!: ElementRef
  @Input('AccessConfig') AccessConfig!: Subject<any>;
  @Input() config: any = {}
  @Input() elementid: string = ''
  @Input() dropout: boolean = false;
  @Input() selectedOption: any = {};
  @Output() onChange = new EventEmitter<any>();
  timestamp: any = new Date().getTime()
  isOpen = false;
  isDefaultSelection: boolean = false
  options: any = []
  groupBy: string = ''
  preffix: string = ''
  categorization: boolean = false
  list: any[] = []
  placeholder: string = 'Select one';
  comparisionField: string = 'field_id';
  className:string = ''
  ngOnInit(): void {
    this.initOptions()
  }
  ngOnChanges() {
    this.initOptions()
  }
  ngAfterViewInit() {
    document.addEventListener('click', (event) => {
      if (this.ltmsdropdown && this.ltmsdropdown.nativeElement !== event.target && !this.ltmsdropdown.nativeElement.contains(event.target)) {
        this.isOpen = false
      }
    });
  }

  initOptions() {
    this.timestamp = new Date().getTime()
    let config = this.config
    this.groupBy = _.get(config, 'groupBy', '');
    this.preffix = _.get(config, 'preffix', '');
    this.comparisionField = _.get(config, 'comparisionField', this.comparisionField);
    this.categorization = _.get(config, 'categorization', false);
    this.isDefaultSelection = _.get(config, 'isDefaultSelection', false);
    this.className =  _.get(config, 'class', '');
    this.options = _.get(config, 'options', []);
    this.placeholder = _.get(config, 'placeholder', 'Select one')
    if (this.options.length > 0 ) {
      if (this.categorization) {
        this.list = this.prepareOptionsByCategory(this.options, this.groupBy)
        if (this.list[0].child_options && this.list[0].child_options.length > 0 && this.isDefaultSelection) {
          this.selectedOption = this.list[0].child_options[0];
          if(config.component_id == 'quick-insight') {
            this.selectedOption = _.filter(this.options, {'isDefaultSelected' : true})[0];
          }
        }
      } else {
        this.list = this.options
        if (this.isDefaultSelection) {
          this.selectedOption = this.list[0]; 
        }
      }
    }
  }

  prepareOptionsByCategory(list: any, field: string) {
    const temp_list = _.groupBy(list, field)
    let categoriesed_list: any[] = []
    _.each(temp_list, (value: any, key: string) => {
      categoriesed_list.push({
        category_name: key.charAt(0).toUpperCase() + key.slice(1),
        child_options: _.filter(value, (object: any) => {
          if (!_.isEmpty(object.name)) {
            return object
          }

        })
      })
    })
    return categoriesed_list
  }

  toggleDropdown(event: any) {
    this.isOpen = !this.isOpen;
    if (this.isOpen && this.dropout) {
      let menu: any = document.getElementById('ltms-dropdown-default-menu-' + this.timestamp);
      if (this.categorization) {
        menu = document.getElementById('ltms-dropdown-categorized-menu-' + this.timestamp);
      }

      const ddButton: any = document.getElementById('ltms-dropdown-button-' + this.timestamp);
      const mainContainer = document.querySelector('.main-container');
      if (menu && ddButton && mainContainer) {

        const rect: any = ddButton.getBoundingClientRect();
        const rect2: any = mainContainer.getBoundingClientRect();
        menu.remove()
        mainContainer.appendChild(menu)
        menu.style.top = rect2.top + (rect2.top + rect.height) + "px";
        menu.style.left = rect.left - rect2.left + "px"
      }
    }
  }


  selectOption(option: any) {
    this.selectedOption = option;
    this.isOpen = false;
    this.onChange.emit(option)
  }
  ngOnDestroy(): void {
    if (this.dropout) {
      let menu: any = document.getElementById('ltms-dropdown-default-menu-' + this.timestamp);
      if (this.categorization) {
        menu = document.getElementById('ltms-dropdown-categorized-menu-' + this.timestamp);
      }
      if (menu) {
        menu.remove();
      }
    }

  }
}
